import {
  getEventData,
  siteEventNames,
} from './events/site-events';
import {
  triggerCustomGA4Event,
} from './utils/data-layer-utils';
/*
  ===========================================================================================================================
  Tag Name                                      GA4 Event Name              Logic
  ---------------------------------------------------------------------------------------------------------------------------
  404 Error                                     404_error                   Custom Event
  Site Error                                    site_error                  Custom Event
  ===========================================================================================================================
*/
const { location } = window;
const { href } = location;

const addEventListeners = () => {
  /*
    ----------------------------------------
    GA4 Event Name: Site Error
    ----------------------------------------
  */
  window.addEventListener(siteEventNames.SITE_ERROR, () => {
    const data = getEventData(siteEventNames.SITE_ERROR);
    const {
      error_line, /* eslint-disable-line camelcase */
      error_message, /* eslint-disable-line camelcase */
    } = data;
    triggerCustomGA4Event({
      event: 'site_error',
      eventModel: {
        error_line,
        error_message,
        error_url: href,
      },
    });
  });
  /*
    ----------------------------------------
    GA4 Event Name: Site Error
    ----------------------------------------
  */
  window.addEventListener(siteEventNames.ERROR_404, () => {
    triggerCustomGA4Event({
      event: '404_error',
      eventModel: {
        error_url: href,
      },
    });
  });
};

window.dataLayerApi = {
  config: () => {
    addEventListeners();
  },
};
